// extracted by mini-css-extract-plugin
export var title = "video-card-module--title--c7HgQ";
export var info = "video-card-module--info--tOZPZ";